import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Conteiner = styled.div`
	width: 100%;
	height: 100%;
	padding-right: 3.6rem;
	padding-top: 3.6rem;
	padding-bottom: 3.6rem;
	padding-left: 3.6rem;
	border-radius: 1.25rem;
`;

export const Content = styled.form`
	width: 100%;
	height: 100%;
	overflow-x: hidden;

	overflow-y: scroll;
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 10px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 10px;
	}

	.DivInput {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.labelForInput {
			display: flex;
			flex-direction: column;
			cursor: pointer;
		}

		.conteinerImg {
			background-color: #e5e5e5;
			width: 5.3rem;
			height: 5.3rem;
			border-radius: 50%;
			padding: 4.5px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.imgForInput {
			width: 4.8rem;
			height: 4.8rem;
			border-radius: 50%;
			object-fit: cover;
		}
	}

	.camera {
		cursor: pointer;
	}

	a {
		text-decoration: none;
	}

	.foto {
		width: 5.5rem;
		height: 5.5rem;
		position: relative;
	}

	.camera {
		position: absolute;
		right: 0;
		top: 60%;
	}

	.header {
		width: 100%;
		margin-left: 1rem;
	}

	.inf {
		margin-top: 4rem;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
	}

	.salve {
		width: 23rem;
		height: 3.625rem;
		min-height: 3rem;

		background-color: ${Colors.primary_blue_k_main};
		color: white;

		font-weight: 700;
		font-size: 1.25rem;

		border: none;
		border-radius: 8px;

		transition: all 0.2s ease;
	}

	.salve:hover {
		background-color: ${Colors.primary_blue_k_dark_2};
	}

	.cancel {
		width: 23rem;
		height: 3.625rem;
		min-height: 3rem;

		background-color: transparent;
		color: ${Colors.primary_blue_k_main};

		font-weight: 700;
		font-size: 1.25rem;

		border: none;
		border-radius: 8px;

		transition: all 0.2s ease;
	}

	.cancel:hover {
		color: ${Colors.primary_blue_k_dark_2};
	}
`;

export const BodyEdite = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 50%);
	grid-row-gap: 4rem;
	margin-top: 3rem;

	.coluna {
		margin: 0 1rem;
	}

	.global {
		width: 100%;
	}

	.globalInput {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: baseline;
		justify-content: center;
	}

	.input {
		width: 100%;
		margin-left: 1rem;
		background-color: white;
		color: #8c8e86;
		font-weight: 500;
		font-size: 1.125rem;
		border: none;
	}

	.select {
		-webkit-appearance: none; /* Remove estilo padrão do Chrome */
		-moz-appearance: none; /* Remove estilo padrão do FireFox */
		appearance: none; /* Remove estilo padrão do FireFox*/
		font-family: "roboto";
		font-weight: 500;
		font-size: 1.125rem;
		color: #8c8e86;
	}

	.select2 {
		font-family: "roboto";
		font-weight: 500;
		font-size: 1.125rem;
		color: #8c8e86;
	}

	.option {
		font-weight: 500;
		font-size: 1.125rem;
		color: #8c8e86;
	}

	.alterSenha {
		margin-left: 1.6rem;
		color: ${Colors.primary_blue_k_medium_1};
		font-weight: 500;
		font-size: 1rem;
	}

	.buttonSenha {
		text-decoration: none;
		display: flex;
		justify-content: space-between;
		cursor: pointer;

		div {
			display: flex;
			align-items: center;
		}
	}

	.buttonSenha:hover {
		text-decoration: none;
	}

	.iconIput {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 1rem;
		height: 1rem;
		position: relative;
		margin-bottom: 0.7rem;
		margin-left: 0.5rem;
	}

	.condicionamento {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 1rem;
		position: relative;
		margin-bottom: 0.6rem;
		margin-left: -0.8rem;
	}

	.icon {
		position: absolute;
	}

	.divhr {
		width: 100%;
	}

	.hr {
		width: 100%;
		background-color: #e0e0e0;
		color: #e0e0e0;
		border: none;
		height: 2px;
	}

	.hrcor {
		background-color: ${Colors.tertirary_red_1_dark};
		color: ${Colors.tertirary_red_1_dark};
	}

	.error {
		margin-top: 0.5rem;
		color: ${Colors.tertirary_red_1_dark};
	}
`;
